import type { Experiment } from '~/server-utils/appRouter/fetchExperimentData';

export const clientSideBrowserCookieIdExperiments: Record<string, never> = {};

export const nccLipExperiment: Record<string, Experiment> = {
  'car-merch-ui-srp-ncc-lip4': {}
};

export const serverSideBrowserCookieIdExperiments = {
  'car-merch-ui-srp-click-to-load': {
    buckets: ['control', 'load-more-every', 'load-more-once']
  },
  'car-merch-ui-srp-vdp-spa-v2': {},
  'quali-srp-carvanads': { buckets: ['control', 'survey'] }
};

export const clientSideUserIdExperiments = {};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...nccLipExperiment,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
